import * as React from 'react';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { Typography } from '@mui/material';
import { FaEdit, FaEye, FaTrash } from 'react-icons/fa';
import {
  formatPrice,
  formatSquareFootage,
  formatNotesDateTime,
} from "../../utils";

export default function StriveNotesDrawer({ expandedNoteId,
                    formattedText,
                    truncatedText,
                    propertyNotes,
                    setExpandedNoteId,
                    setNotesId,
                    setTextInput,
                    setIsShowAddNotes,
                    setIsNotesReadOnly,
                    loggedinuser,
                    handleDeleteNote,
                    showPorpertyNotes, 
                    isInvestorEdit
                    }) {
  const [state, setState] = React.useState({
    left: false,
  });
  const isSideBarOpen = JSON.parse(sessionStorage.getItem("isOpenSidebar"));
  const storedUserData = JSON.parse(sessionStorage.getItem("userData") || "{}");
  const loginUserId = storedUserData && storedUserData.id ? storedUserData.id : "";

  //  Separate into investorNotesData and propertyNotesData dynamically
const investorNotesData = React.useMemo(
  () => (propertyNotes || []).filter(
    note => "user_id" in note && note.deleted !== 1
  ),
  [propertyNotes]
);


  const propertyNotesData = React.useMemo(
    () => (propertyNotes || []).filter(note => !("user_id" in note)),
    [propertyNotes]
  );

  const toggleDrawer = (anchor, open) => (event) => {
    // setSelectedPropertySellerId(contactId);
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const renderNotes = (notes, anchor) => {
    return notes && notes.length > 0 ? (
      notes.map((item) => {
       const createdBy = item.CREATED_BY && item.CREATED_BY
                       || item.user_name && item.user_name 
                       || "N/A";

        const formattedName = createdBy.charAt(0).toUpperCase() + createdBy.slice(1);

        const dateValue = item.CREATED || item.arcimedes_modified || "";
        const formattedDate = dateValue ? formatNotesDateTime(dateValue) : "";

        const noteText = item.NOTES || item.text || "";
        const formattedText = (
  <div>
    {formattedDate} <strong>{formattedName}</strong>:<br />
    {noteText}
  </div>
);
        const canEditNote = loginUserId === Number(item.user_id) || (loggedinuser && item && item.CREATED_BY && loggedinuser.toLowerCase() === item.CREATED_BY.toLowerCase());

        return (
          <React.Fragment key={item.ARCIMEDES_ROW_ID || item.arcimedes_row_id}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                mb: 2,
                px: 1,
              }}
            >
              <Box sx={{ flex: 1, pr: 1 }}>
                <Typography
                  variant="body2"
                  sx={{
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    fontSize: "14px",
                    lineHeight: 1.5,
                  }}
                >
                  {formattedText}
                </Typography>
              </Box>

              <Box sx={{ minWidth: "24px", textAlign: "right" }}>
                <button
                  onClick={() => {
                    if (isInvestorEdit) {
                      isInvestorEdit.current = showPorpertyNotes ? false : true;
                    }
                    setNotesId(
                      showPorpertyNotes
                        ? item.ARCIMEDES_ROW_ID
                        : item.arcimedes_row_id
                    );
                    setTextInput(item.NOTES || item.text);
                    setIsShowAddNotes(true);
                    setIsNotesReadOnly(!canEditNote);
                    toggleDrawer(anchor, false)();
                  }}
                  style={{
                    cursor: "pointer",
                    fontSize: "15px",
                    color: "#424242",
                    background: "transparent",
                    border: "none",
                    padding: "2px",
                  }}
                >
                  {(loggedinuser &&
                    item &&
                    item.CREATED_BY &&
                    loggedinuser.toLowerCase() ===
                      item.CREATED_BY.toLowerCase()) ||
                  loginUserId === Number(item.user_id) ? (
                    <FaEdit />
                  ) : (
                    <FaEye />
                  )}
                </button>
                {(loggedinuser &&
                  item &&
                  item.CREATED_BY &&
                  loggedinuser.toLowerCase() ===
                    item.CREATED_BY.toLowerCase()) ||
                loginUserId === Number(item.user_id) ? (
                  <button
                    onClick={() => {
                      const isContactNote = !!item.user_id;
                      setNotesId(isContactNote);
                      handleDeleteNote(item);
                      setTextInput([item]);
                    }}
                    style={{
                      cursor: "pointer",
                      fontSize: "15px",
                      color: "#d32f2f",
                      background: "transparent",
                      border: "none",
                      padding: "2px",
                    }}
                  >
                    <FaTrash />
                  </button>
                ) : null}
              </Box>
            </Box>
            <Divider sx={{ my: 1 }} />
          </React.Fragment>
        );
      })
    ) : (
      <Typography variant="body2" align="center" color="textSecondary">
        No notes available.
      </Typography>
    );
  };

  const list = (anchor) => (
    <div>
      <Typography
        variant="h6"
        align="center"
        sx={{ mb: 2, fontWeight: 600 }}
      >
        NOTES
      </Typography>

      {/* ✅ Conditionally show Investor or Property notes */}
      {showPorpertyNotes 
        ? renderNotes(propertyNotesData, anchor) 
        : renderNotes(investorNotesData, anchor)}
    </div>
  );

  return (
    <div >
      {["left"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Button 
            style={{color:"#7EB233",marginTop: showPorpertyNotes ? "2px" : "5px", fontSize:"small",  fontWeight: showPorpertyNotes ?  600 : 400,textTransform: "none", marginLeft:"10px"}} 
            onClick={toggleDrawer(anchor, true)}
          >
            Show Notes
          </Button>
          <SwipeableDrawer
            anchor={anchor}
            hysteresis={2}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            onOpen={toggleDrawer(anchor, true)}
            PaperProps={{
              sx: {
                width: "410px",  
                borderRadius:"10px",
                height: '90%',
                marginTop: '65px',
                marginLeft: isSideBarOpen ? '299px' : '65px',
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column',
              },
            }}
          >
            {list(anchor)}
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </div>
  );
}
